export interface LoginMessage {
  code: string;
  state: string;
}

const codePattern = /^[a-zA-Z0-9_-]+$/;
const statePattern = /^[A-Za-z0-9_.-]+$/;

export function parseLoginMessage(message: string): LoginMessage {
  const parsed = JSON.parse(message) as LoginMessage;
  if (!parsed.code || !codePattern.test(parsed.code) || !parsed.state || !statePattern.test(parsed.state)) {
    throw new Error("Invalid SDA callback message");
  }
  return parsed;
}

export function isTrustedDialogMessage(
  event: Pick<MessageEvent, "origin" | "source">,
  childWindow: Window,
  expectedOrigin: string
): boolean {
  return event.origin === expectedOrigin && event.source === childWindow;
}
